export const MALWARE_TAG_LABEL = 'Blocked';

export const MALWARE_TAG_TOOLTIP =
  'Blocked by malware scanning — content cannot be opened or downloaded';
